import { Grid } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import { useState } from "react";
import { CSVLink } from "react-csv";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useCustomerValue } from "providers/CustomerContext";
import { useTeamValue } from "providers/TeamContext";
import { getEmptyLocationEnquiry } from "services/data.report.service";
import { getCustomerOptions } from "services/data.internal.service";
import { ExportButton } from "ui-components/Button";
import { SelectFields } from "ui-components/Form";
import { LoadingDialog, Success, Error, ExportDialog } from "ui-components/Alert";
import { TableCard, ListLayout } from "ui-components/Layout";
import BasicTable from "ui-components/tables/BasicTable";
import { EmptyLocationColumns } from "./columns";
import useCsvDownloadHook from "hooks/useCsvDownloadHook";

function EmptyLocationEnquiry() {
  const { permissions, allowAll } = useTeamValue();
  const { customerCode, customerOpt } = useCustomerValue();
  const { isDownloading, downloadCsv } = useCsvDownloadHook();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const exportPermission = allowAll ||
    (Boolean(permissions["Empty Location_Report"]) &&
    permissions["Empty Location_Report"].findIndex((b) => b === "export") !== -1);
  const handleFilterRowsChange = (filteredData) => { setFilteredData(filteredData); };
  const [alert, setAlert] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [customerOptions, setCustomerOptions] = useState([]);
  const { refetch, isFetching } = useQuery({
    queryKey: ["stock-inventory-enquiry", { customers }],
    queryFn: () => getEmptyLocationEnquiry({ customerCode, customers }),
    enabled: Boolean(customerCode) && Boolean(customers.length),
    onSuccess: (data) => {
      setData(data.data.data);
      setFilteredData(data.data.data);
    },
    onError: () => { },
  });

  useQuery({
    queryKey: ["customer-options", {customerCode}],
    queryFn: () => getCustomerOptions(),
    onSuccess: (data) => {
      const activeCust = customerOpt.filter(x => data.data.some(y => y === x));
      setCustomerOptions(activeCust);
      setCustomers([customerCode])
    },
    onError: () => { },
  })

  const onSuccess = (data) => {
    setAlert(<Success data={data} onChange={setAlert} />);
  };
  const onError = (data) => {
    setAlert(<Error data={data} onChange={setAlert} />);
  };

  return (
    <ListLayout>
      {isFetching && <LoadingDialog />}
      {isDownloading && <ExportDialog />}
      {alert && <MDBox sx={{ my: 3 }}>{alert}</MDBox>}
      <TableCard sx={{ my: 3 }}>
        <MDBox margin="1rem 1rem 0 1rem">
          <Grid container spacing={3}>
            {/* <Grid item xs={3}>
              {(Boolean(customerOptions) && Boolean(customerOptions.length)) && (
                <SelectFields
                  field={{
                    name: "",
                    label: "Customers",
                    value: customers,
                    errors: {},
                    multiple: true,
                  }}
                  options={customerOptions}
                  onChange={(e, v) => setCustomers(v)}
                />
              )}
            </Grid> */}
            <Grid item xs={4}>
              <MDButton
                sx={{ marginLeft: "1rem" }}
                variant="gradient"
                color="info"
                disabled={!exportPermission}
                onClick={() => {
                  const filename = `${customers.join(', ')}_${dayjs(new Date()).format("YYYYMMDD-HHmm")}_EmptyLocation`;
                  downloadCsv(filename, filteredData)
                }}
              >
                Export
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>
        <BasicTable
          data={data}
          columns={EmptyLocationColumns}
          onFilterRowsChange={handleFilterRowsChange}
        />
      </TableCard>
    </ListLayout>
  );
}

export default EmptyLocationEnquiry;
